import { useState } from "react";
import { z } from "zod";
import { Alert, Card, CardBody, PageHeader } from "@fellowflats/ui";
import { api } from "../lib/api";
import { ActionButton } from "../components/bits";

const JOBS = [
  ["booking-expiry", "Expire requests unanswered for 72 hours, and tell the renter."],
  ["inquiry-sla-sweep", "Mondays: nudge landlords with overdue requests; pause listings ignored for a week."],
  ["review-reminders", "Ask both sides of a finished stay for a review."],
  ["saved-search-alerts", "Email and notify saved searches about new listings."],
  ["featured-sweep", "End featuring that has run out."],
  ["fx-refresh", "Refresh the indicative exchange rates."],
] as const;

const ReportSchema = z.object({
  ok: z.boolean(),
  ms: z.number(),
  processed: z.number(),
  skipped: z.number(),
  failed: z.number(),
  note: z.string().optional(),
  more: z.boolean().optional(),
});

/** Run one batch of a scheduled job now, the same way the daily run does. */
export function Jobs() {
  const [results, setResults] = useState<Record<string, z.infer<typeof ReportSchema>>>({});
  return (
    <div className="space-y-6">
      <PageHeader title="Jobs" description="They run daily at 14:00 UTC. Run one now to check it; each run is one batch of at most 50 rows." />
      {JOBS.map(([name, what]) => {
        const r = results[name];
        return (
          <Card key={name}>
            <CardBody className="flex flex-wrap items-start justify-between gap-3 p-5">
              <div>
                <p className="font-mono text-sm font-semibold">{name}</p>
                <p className="text-sm text-muted-foreground">{what}</p>
                {r && (
                  <div className="mt-2">
                    <Alert tone={r.ok ? (r.failed ? "warning" : "success") : "error"}>
                      {r.ok
                        ? `${r.processed} done, ${r.skipped} skipped, ${r.failed} failed in ${r.ms} ms${r.more ? "; more left, run again" : ""}${r.note ? ` (${r.note})` : ""}`
                        : "The job failed; see the Worker logs."}
                    </Alert>
                  </div>
                )}
              </div>
              <ActionButton run={async () => setResults({ ...results, [name]: await api("POST", `/admin/jobs/${name}/run`, ReportSchema) })}>
                Run now
              </ActionButton>
            </CardBody>
          </Card>
        );
      })}
    </div>
  );
}
